import { FiAlertTriangle, FiX } from "react-icons/fi";

const THEME = { primary: "#FB565F" };

export default function ConfirmWarningModal({
  open,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onClose,
  onConfirm,
  confirming = false,
  variant = "warning",
}) {
  if (!open) return null;

  const isDanger = variant === "danger";
  const accent = isDanger ? THEME.primary : "#D97706";
  const accentBg = isDanger ? "bg-rose-50" : "bg-amber-50";
  const accentBorder = isDanger ? "border-rose-200" : "border-amber-200";
  const accentText = isDanger ? "text-rose-800" : "text-amber-800";

  const paragraphs =
    typeof message === "string"
      ? message.split(/\n+/).filter(Boolean)
      : Array.isArray(message)
        ? message
        : message
          ? [message]
          : [];

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4"
      onClick={confirming ? undefined : onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-warning-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-start justify-between gap-3 px-5 py-4 border-b"
          style={{ borderColor: `${accent}33` }}
        >
          <div className="flex items-start gap-3 min-w-0">
            <div
              className={`flex-shrink-0 p-2 rounded-full ${accentBg}`}
              style={{ color: accent }}
            >
              <FiAlertTriangle size={20} />
            </div>
            <div className="min-w-0">
              <h3 id="confirm-warning-title" className="font-bold text-gray-900 text-base">
                {title}
              </h3>
              {paragraphs.length > 0 ? (
                <div className={`mt-2 text-sm ${accentText} space-y-2`}>
                  {paragraphs.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={confirming}
            className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 disabled:opacity-40 flex-shrink-0"
            aria-label="Close"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className={`px-5 py-3 text-xs ${accentBg} ${accentBorder} border-t border-b`}>
          <p className={accentText}>
            This action cannot be undone. Please review before continuing.
          </p>
        </div>

        <div className="px-5 py-4 flex flex-col-reverse sm:flex-row justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={confirming}
            className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming}
            className="px-4 py-2 text-sm rounded-lg text-white font-semibold disabled:opacity-50"
            style={{ backgroundColor: accent }}
          >
            {confirming ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
